import { Box, Button, Typography } from "@mui/material"
import { type FC, useEffect, useMemo, useState } from "react"

import { getPayRunPreviewItems, getPayRunPreviewSelectedPayDays } from "../utils/paymentTerms"

import type { PayPatternGql } from "@/graphql/codegen/graphql"

interface PayRunPreviewProps {
  payPattern: PayPatternGql
  payDays?: string
}

const PayRunPreview: FC<PayRunPreviewProps> = ({ payPattern, payDays }) => {
  const [selected, setSelected] = useState<number[]>([])
  const items = useMemo(() => getPayRunPreviewItems(payPattern), [payPattern])

  useEffect(() => {
    setSelected(getPayRunPreviewSelectedPayDays(payPattern, payDays))
  }, [payDays, payPattern])

  const isSelected = (index: number) => {
    return selected.includes(index + 1)
  }

  return (
    <Box className='mt-4 flex flex-col'>
      <Box>
        <Typography variant='body2'>Pay Run Preview</Typography>
      </Box>

      <Box className='mt-2 flex flex-row flex-wrap overflow-x-auto'>
        {items.map((item, index) => (
          <Button
            key={`${item}-${index}`}
            size='small'
            variant={isSelected(index) ? "contained" : "outlined"}
            className='pointer-events-none size-[36px] min-w-[36px] rounded-none'
          >
            {item}
          </Button>
        ))}
      </Box>
    </Box>
  )
}

export default PayRunPreview
